export default {"src":"/_next/static/media/contact_icon.973b4730.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};